// extracted by mini-css-extract-plugin
export default {"mainCont":"MainContainer_mainCont__ggeJ2","scrollCont":"MainContainer_scrollCont__L4BRk","vidaGifCont":"MainContainer_vidaGifCont__I24zX","vidaGif":"MainContainer_vidaGif__3yb2Z"};